var map = {
	"./ADA.svg": 735,
	"./BCH.svg": 736,
	"./BNB.svg": 737,
	"./BTC.svg": 738,
	"./CHZ.svg": 739,
	"./DASH.svg": 740,
	"./DOGE.svg": 741,
	"./DOT.svg": 742,
	"./ETC.svg": 743,
	"./ETH.svg": 744,
	"./EUR.svg": 745,
	"./GBP.svg": 746,
	"./LINK.svg": 747,
	"./LTC.svg": 748,
	"./MATIC.svg": 749,
	"./MKR.svg": 750,
	"./SHIB.svg": 751,
	"./SOL.svg": 752,
	"./TRX.svg": 753,
	"./UNI.svg": 754,
	"./USD.svg": 755,
	"./USDT.svg": 756,
	"./XLM.svg": 757,
	"./XMR.svg": 758,
	"./XRP.svg": 759,
	"./documents.svg": 760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 734;